import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Faq from 'components/Common/Faq'

const FaqSectionWrapper = styled.div`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)} 0;
  }
`

function LuxPlusLandingFaqSection() {
  const intl = useIntl()

  return (
    <FaqSectionWrapper>
      <LayoutContainer variant="medium">
        <Heading variant="heading3" as="h2">
          {intl.formatMessage({
            id: 'x_jFKIihdA42L7m9Fqqg',
            defaultMessage: 'Frequently Asked Questions',
            description: 'Heading for the FAQ section on the LuxPlus landing page',
          })}
        </Heading>
        <Faq slug="luxplus-faqs" />
      </LayoutContainer>
    </FaqSectionWrapper>
  )
}

export default LuxPlusLandingFaqSection
